// extracted by mini-css-extract-plugin
export default {"body":"Loading_body__raMUm","wrapper":"Loading_wrapper__dX-L7","ul":"Loading_ul__GNBiK","rot":"Loading_rot__RmEA8","li":"Loading_li__hNKHj","scale":"Loading_scale__N+XUc"};